import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = {
  key: 0,
  class: "table table-hover"
}
const _hoisted_3 = {
  key: 1,
  class: "table table-hover"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"container\" style=\"margin-top:80px;padding-top:40px;\"><div class=\"row\"><div class=\"col-lg-6\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;margin:0;\">Dependencies</h1></div><div class=\"col-lg-6 text-right\"></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 60px;\">", 2)),
    (_ctx.rm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "btn btn-outline-secondary mr-1",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleViewBy && _ctx.toggleViewBy(...args)))
          }, "View by: " + _toDisplayString(_ctx.ViewBy), 1 /* TEXT */),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)))
          }, "Filter: " + _toDisplayString(_ctx.Filter), 1 /* TEXT */),
          _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          (_ctx.ViewBy === 'Foundation')
            ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
                _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Foundation"),
                    _createElementVNode("th", null, "Dependents")
                  ])
                ], -1 /* CACHED */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FoundationsView, (f) => {
                  return (_openBlock(), _createElementBlock("tbody", {
                    key: f.AlternativeId
                  }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _withDirectives((_openBlock(), _createElementBlock("a", null, [
                          _createTextVNode(_toDisplayString(f.Name), 1 /* TEXT */)
                        ])), [
                          [_directive_sanitizedHref, _ctx.url_AlternativeDashboardPage(f.Id)]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDependents(f), (d) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: d.Id
                          }, [
                            _withDirectives((_openBlock(), _createElementBlock("a", null, [
                              _createTextVNode(_toDisplayString(d.Name), 1 /* TEXT */)
                            ])), [
                              [_directive_sanitizedHref, _ctx.url_AlternativeDashboardPage(d.Id)]
                            ]),
                            _cache[2] || (_cache[2] = _createTextVNode(", ", -1 /* CACHED */))
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.ViewBy === 'Dependent')
            ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
                _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, "Dependent"),
                    _createElementVNode("th", null, "Foundations"),
                    _createElementVNode("th", { style: {"width":"100px"} })
                  ])
                ], -1 /* CACHED */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DependentsView, (d) => {
                  return (_openBlock(), _createElementBlock("tbody", {
                    key: d.AlternativeId
                  }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _withDirectives((_openBlock(), _createElementBlock("a", null, [
                          _createTextVNode(_toDisplayString(d.Name), 1 /* TEXT */)
                        ])), [
                          [_directive_sanitizedHref, _ctx.url_AlternativeDashboardPage(d.Id)]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFoundations(d), (f) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: f.Id
                          }, [
                            _withDirectives((_openBlock(), _createElementBlock("a", null, [
                              _createTextVNode(_toDisplayString(f.Name), 1 /* TEXT */)
                            ])), [
                              [_directive_sanitizedHref, _ctx.url_AlternativeDashboardPage(f.Id)]
                            ]),
                            _cache[4] || (_cache[4] = _createTextVNode(", ", -1 /* CACHED */))
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}